// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3cgqO","capitilize":"styles_capitilize__kC7y7","description":"styles_description__3Axv4"};